import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

const RopopochodneCreator = () => {
  const { t } = useTranslation();
  
  return (
    <div>
    <Typography variant="h4" gutterBottom>{t('ropopochodne')}</Typography>
    </div>
  );
};

export default RopopochodneCreator;